export const localStorageKeys = {
  visitorId: "visitorId",
  congratsPageValues: "congratsPageValues",
  leadLocalStorageItem: "LeadiD-request-catalog",
  lastSubmittedData: "lastSubmittedData",
  vl_click_id: "vl_click_id"
};

export const sessionStorageKeys = {
  isClickIdStored: "isClickIdStored",
  rgba: "rgba",
  generatorName: "generatorName",
  generator: "generator",

  queryStrings: 'queryStrings',

  
  dataLayer:"dataLayer",
  clickId: "vl_click_Id",
  eventID: "eventID",

  ringbaDetails: "rignbaDetails",

  zip: "zip",
  city: "city",
  state: "state",

  firstName: "firstName",
  lastName: "lastName",

  homePhone: "homePhone",
  email: "email",

  finalPreparedData:"finalPreparedData",
  submitSuccessful: "submitSuccessful",

  fbc: "fbc",
  fbp: "fbp",

  lead_id: "lead_id",
  user_agent: "user_agent",
  zipCodeExtraValues:"zipCodeExtraValues",

  fbPixelId: "fbPixelId",
  domainName: "domainName",
  userIp: "userIp",

  gclid: "gclid",
  grbaid: "grbaid",
  wbraid: "wbraid",
  acc_id: "acc_id",
  placement: "placement"
};

export const STORAGE_KEYS = { sessionStorageKeys, localStorageKeys }